import Reveal from "@/components/base/Reveal";
import { profileFields, profileParagraphs, profileHighlights } from "@/mocks/siteContent";

export default function ProfileSection() {
  return (
    <section id="profile" className="scroll-mt-20 w-full bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <Reveal>
          <div className="flex items-center gap-3 mb-3">
            <span className="h-px w-8 bg-primary-400"></span>
            <span className="font-label text-xs md:text-sm tracking-widest text-primary-600 uppercase">
              Profile
            </span>
          </div>
          <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-4xl">
            夏目彩春个人资料
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-3xl leading-relaxed">
            以下资料由公开网络信息汇总整理，部分内容存在不同说法，已在条目中标注，请结合官方渠道核对。
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          {/* image */}
          <Reveal className="lg:col-span-5">
            <div className="w-full h-[320px] md:h-[440px] rounded-2xl overflow-hidden border border-background-200 bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20elegant%20silhouette%20of%20a%20woman%20against%20a%20warm%20blush%20pink%20wall%20with%20soft%20window%20light%2C%20minimal%20artistic%20portrait%2C%20soft%20focus%2C%20editorial%20photography%20style%2C%20calm%20and%20refined%20mood&width=800&height=1000&seq=natsume-profile-02&orientation=portrait"
                alt="夏目彩春个人资料配图，暖色调人物剪影示意"
                title="夏目彩春 个人资料整理"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="mt-5 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-1 gap-3">
              {profileHighlights.map((h) => (
                <div
                  key={h.title}
                  className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-100 p-3.5"
                >
                  <span className="w-9 h-9 shrink-0 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center">
                    <i className={`${h.icon} text-lg`}></i>
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{h.title}</p>
                    <p className="text-xs text-foreground-600 mt-1 leading-relaxed">
                      {h.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>

          {/* fields + paragraphs */}
          <Reveal className="lg:col-span-7" delay={100}>
            <div className="rounded-2xl border border-background-200 bg-background-50 overflow-hidden">
              <div className="px-5 py-3.5 bg-secondary-100 border-b border-background-200 flex items-center gap-2">
                <i className="ri-file-list-3-line text-secondary-900"></i>
                <span className="text-sm font-semibold text-secondary-900 font-label">
                  资料速览
                </span>
              </div>
              <dl className="divide-y divide-background-200">
                {profileFields.map((f) => (
                  <div
                    key={f.label}
                    className="grid grid-cols-1 sm:grid-cols-3 gap-1 sm:gap-4 px-5 py-3.5"
                  >
                    <dt className="text-xs md:text-sm text-foreground-500 font-label">
                      {f.label}
                    </dt>
                    <dd className="sm:col-span-2 text-sm text-foreground-900 leading-relaxed">
                      {f.value}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>

            <div className="mt-6 space-y-4">
              {profileParagraphs.map((p, i) => (
                <p
                  key={i}
                  className="text-sm md:text-base text-foreground-700 leading-relaxed"
                >
                  {p}
                </p>
              ))}
            </div>

            <div className="mt-6 flex items-start gap-3 rounded-lg border border-accent-300 bg-accent-50 p-4">
              <i className="ri-information-line text-accent-700 text-lg mt-0.5"></i>
              <p className="text-xs md:text-sm text-foreground-800 leading-relaxed">
                提示：网络上关于她的资料存在多个版本，本页不将推测当作既定事实。若你在别处看到更权威的公开信息，欢迎对照参考。
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}